import $ from 'jquery';

// OA-181 Form specifiek add on
$().ready(function() {
  $('.move-form').appendTo('.formOverlayPlaceholder');
});
